<template>
  <div class="col-12">
    <div class="py-1 px-4 rounded">
      <div class="row mt-4">
        <div class="col-12 d-flex">
          <i class="fas fa-calendar-plus text-orange mr-2 mt-1"></i>
          <p class="font-weight-normal font-18">
            {{ componentName }}
          </p>
        </div>
      </div>
      <ValidationObserver ref="PeiTransitionStudentSAEE12Documenty">
        <div class="row">
          <div class="col-12 col-md-2">
            <ValidationProvider
              v-slot="{ errors }"
              name="date"
              rules="required"
            >
              <custom-date-picker
                v-model="model.dateDiscussion"
                required
                label="Fecha de Discusión"
                placeholder="DD/MM/YYYY"
                :min-date="minDate"
                :error="errors[0]"
                custom-error-msg="La fecha de discusión es requerida."
              />
            </ValidationProvider>
          </div>
          <div style="cursor:pointer !important" class="col-12 col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <label class="color-gray-6 font-14 font-weight-bold">
                Archivo:
              </label>
              <custom-file-input
                ref="fileUpload"
                v-model="model.fileDiscussion"
                display-style="normal"
                :on-download="downloadFile"
                :accept="'.pdf'"
                class="w-100"
                label-position="left"
                :error="errors[0]"
                custom-error-msg="El documento es requerido."
              />
            </validation-provider>
          </div>
          <div class="col-12">
            <div class="main-content mt-2">
              <div class="mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="reason"
                  rules="required"
                >
                  <custom-text-area
                    v-model="model.comment"
                    required
                    :maxlength="3000"
                    label="Comentario:"
                    :error="errors[0]"
                    :custom-error-msg="'El Comentario es requerido'"
                    show-char-count
                    :count-classes="['d-block', 'small-counter', 'text-right']"
                  />
                </ValidationProvider>
              </div>
              <div class="d-flex justify-content-end align-items-center px-0">
                <action-button
                  type="button"
                  text="Cancelar"
                  i="fa fa-times-circle"
                  variant="outline-danger"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="close()"
                />

                <action-button
                  type="button"
                  text="Guardar"
                  i="fas fa-save"
                  variant="success"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="save()"
                />
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import transitionStudentService from "@/services/pei/transitionStudent.js";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import CustomDatePicker from "custom-date-picker";
import CustomFileInput from "CustomFileInput";
import alert from "@/mixin/alert.mixin";
import objectToFormData from "object-to-formdata";

export default {
  name: "PeiTransitionStudentSAEE12Documenty",
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomTextArea,
    ActionButton,
    CustomDatePicker,
    CustomFileInput
  },
  data: () => ({
    model: {
      dateDiscussion: null,
      fileDiscussion: null,
      comment: null
    },
    newDocumentId: null
  }),
  mixins: [alert],
  mounted() {},
  props: {
    transitionStudentSAEE12Id: {
      type: Number,
      default: null,
      require: true
    },
    componentName: {
      type: String,
      default: null,
      require: true
    },
    minDate: {
      type: Date,
      default: null,
      require: true
    }
  },
  methods: {
    downloadFile() {},
    async save() {
      const isValid = await this.$refs.PeiTransitionStudentSAEE12Documenty.validate();

      if (!isValid) {
        this.ShowToast(
          "Error",
          "Favor de completar la información solicitada.",
          "error"
        );
        return;
      }

      const model = {
        transitionStudentSAEE12Id: this.transitionStudentSAEE12Id,
        ...this.model
      };

      const formData = objectToFormData(model, { indices: true });

      await transitionStudentService.saveDiscussion(formData).then(
        results => {
          this.ShowToast(
            "Proceso exitoso.",
            "La discusión se ha guardado correctamente.",
            "success"
          );
          this.newDocumentId = results.data;
          this.close();
        },
        error => {
          this.ShowToast("Alerta", `${error.response.data.message}.`, "error");
        }
      );
    },
    async close() {
      this.model.dateDiscussion = null;
      this.model.fileDiscussion = null;
      this.model.comment = null;
      this.$emit("onClose", this.newDocumentId);
    }
  }
};
</script>

<style lang="scss" scoped></style>
